import React from 'react';
import HospitalUI from './HospitalUI';
export var SearchHospitalCard = function () {
    var test = '222';
    return React.createElement(HospitalUI, { test: test });
};
